<template>
  <video :class="{rotate: shouldRotate}" autoPlay muted playsInline ref="videoEl"/>
</template>

<script>
export default {
  name: "VideoTrack",
  props: ["track", "isMediaStream", "rotate"],
  mounted() {
    const videoEl = this.$refs.videoEl;
    videoEl.srcObject = this.isMediaStream
        ? this.track
        : new MediaStream([this.track]);
  },
  computed: {
    shouldRotate() {
      return this.rotate ?? true
    }
  }
};
</script>

<style scoped>
video {
  width: 100%;
  height: 100%;
  object-position: center;
  object-fit: cover;
  border-radius: 16px;
  overflow: hidden;

  max-height: inherit;
  max-width: inherit;
}

video.rotate {
  transform: rotateY(180deg);
}
</style>
